import { render, staticRenderFns } from "./JobTypeChip.vue?vue&type=template&id=aadf7bc4&scoped=true&"
import script from "./JobTypeChip.vue?vue&type=script&lang=js&"
export * from "./JobTypeChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadf7bc4",
  null
  
)

export default component.exports